import script from "./FeatureListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeatureListItem.vue?vue&type=script&setup=true&lang=ts"

import "./FeatureListItem.vue?vue&type=style&index=0&id=55054904&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55054904"]])

export default __exports__